import React from 'react';
import { useTranslation } from 'react-i18next';

import { OnboardingCreatorInfoBlock } from 'components';
import { ThemeCustomizationForm } from 'containers/forms';
import { PropTypes } from 'prop-types';
import { useAuthStore } from 'stores/authStore';

const OnboardingThemeCustomizationPage = ({ onNext, onLogout }) => {
  const { t } = useTranslation(['pages']);
  const theme = useAuthStore((state) => state.user?.admin_details?.brand?.theme);

  return (
    <>
      <h1 className="display-4 text-center">{t('onboarding.themeCustomTitle')}</h1>
      <h4 className="text-muted text-center">{t('onboarding.themeCustomSubtitle')}</h4>
      <OnboardingCreatorInfoBlock onLogout={onLogout} />
      <ThemeCustomizationForm initialValues={theme} onNext={onNext} />
    </>
  );
};

OnboardingThemeCustomizationPage.propTypes = {
  onNext: PropTypes.func.isRequired,
  onLogout: PropTypes.func,
};

export default OnboardingThemeCustomizationPage;
